import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChooseGuard } from './guards/choose.guard';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { SuperAdminGuard } from './guards/superadmin.guard';
import { CitipostOnlyGuard } from './guards/citipostonly.guard';
import { ChooseComponent } from './choose.component';
import { AdminComponent } from './admin.component';
import { ShopLandingComponent } from './shoplanding.component';
import { NoShopComponent } from './noshop.component';
import { RedirectComponent } from './redirect.component';
import { DeniedComponent } from './denied.component';
import { LogoutComponent } from './logout.component';

const routes: Routes =  [

  { path: '', component: RedirectComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
  { path: 'choose', component: ChooseComponent, canActivate: [ChooseGuard] },// don't allow the Shopper
  { path: 'noshop', component: NoShopComponent },// don't allow the Shopper
  { path: 'admin', component: AdminComponent, canActivate: [AdminGuard] },
  { path: 'denied', component: DeniedComponent},
  { path: 'shopservices', component: ShopLandingComponent, canActivate: [AuthGuard] },// don't allow the Shopper
  
  {
    path: 'tools', canActivate: [AdminGuard],
      loadChildren: () => import('./tools/tools.module').then(m => m.ToolsModule)
    },
    { path: 'reports', canActivate: [AdminGuard],
     loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
    },
    { path: 'citipost', canActivate: [SuperAdminGuard],
      loadChildren: () => import('./citipost/citipost.module').then(m => m.CitipostModule)
    },
    { path: 'orders', canActivate: [CitipostOnlyGuard],
      loadChildren: () => import('./csorders/csorders.module').then(m => m.CSOrdersModule)
    },
    { path: 'shop', canActivate: [AuthGuard],
      loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
  },
  {
    path: 'specsavers', canActivate: [AuthGuard],
    loadChildren: () => import('./specsavers/specsavers.module').then(m => m.SpecsaversModule)
  },
  {
    path: 'trakii', canActivate: [AuthGuard],
    loadChildren: () => import('./trakii/trakii.module').then(m => m.TrakiiModule)
  }
  ,
  {
    path: 'lensdispatch', canActivate: [AuthGuard],
    loadChildren: () => import('./lensdispatch/lensdispatch.module').then(m => m.LensDispatchModule)
  }
    
];



@NgModule({
  imports: [RouterModule.forRoot(routes)], //, { onSameUrlNavigation: 'reload' }
  exports: [RouterModule]
})

export class AppRoutingModule { }


